import React from 'react';

import { DownOutlined } from '@ant-design/icons';
import {
  Button as AntdButton,
  Dropdown as AntdDropdown,
  MenuProps,
} from 'antd';

import {
  ConditionsReactivateJuridictionDto,
  JuridictionAdminResponseDto,
} from 'lib_api/lib/api/gen';

import { useModal } from 'hooks/modal/useModal';

import ModalDesactivation from '../Modals/ModalDesactivation/ModalDesactivation';
import ModalReactivation from '../Modals/ModalReactivation/ModalReactivation';

import ConditionReactivateJuridiction from './ConditionReactivate/ConditionReactivateJuridiction';
import ModalDetails from './Modals/ModalDetails';
import ModalUpdate from './Modals/ModalUpdate';
import UsesJuridiction from './UsesJuridiction/UsesJuridiction';
import { useActivationJuridiction } from './utils/useActivation';

const TITRE_DESACTIVATION = 'Désactiver la juridiction';
const TITRE_REACTIVATION = 'Réactiver la juridiction';

interface CellDetailsAndActionsProps {
  juridiction: JuridictionAdminResponseDto;
  refreshDashboard: () => void;
}

function CellDetailsAndActions({
  juridiction,
  refreshDashboard,
}: CellDetailsAndActionsProps): React.ReactElement {
  const modalDetails = useModal();
  const modalUpdate = useModal();
  const modalDeprecate = useModal();

  const {
    submitReactivate,
    submitDeprecate,
    conditionsReactivate,
    getUsesJuridiction,
  } = useActivationJuridiction();

  const conditionUnlock = (
    conditions?: ConditionsReactivateJuridictionDto,
  ): boolean => {
    return conditions?.reactivationAvailable ?? false;
  };

  const items: MenuProps['items'] = [
    {
      key: 'update',
      label: 'Modifier',
      onClick: modalUpdate.open,
    },
    {
      key: 'desactiver',
      label: juridiction.valid ? TITRE_DESACTIVATION : TITRE_REACTIVATION,
      onClick: modalDeprecate.open,
    },
  ];

  function ModalDesactivationReactivation() {
    return juridiction.valid ? (
      <ModalDesactivation
        idCorrelation={juridiction.idCorrelation}
        titleModal={TITRE_DESACTIVATION}
        submitDeprecate={submitDeprecate}
        visible={modalDeprecate.visible}
        close={modalDeprecate.close}
        callAfterSubmit={refreshDashboard}
        componentUses={UsesJuridiction}
        usesRequest={getUsesJuridiction}
      />
    ) : (
      <ModalReactivation
        idCorrelation={juridiction.idCorrelation}
        titleModal={TITRE_REACTIVATION}
        visible={modalDeprecate.visible}
        close={modalDeprecate.close}
        callAfterSubmit={refreshDashboard}
        conditionRequest={conditionsReactivate}
        componentConditions={ConditionReactivateJuridiction}
        conditionUnlock={conditionUnlock}
        reactivateRequest={submitReactivate}
      />
    );
  }

  return (
    <>
      <AntdButton onClick={modalDetails.open}>Détails</AntdButton>
      <ModalDetails
        juridiction={juridiction}
        visible={modalDetails.visible}
        close={modalDetails.close}
      />
      <ModalUpdate
        juridiction={juridiction}
        visible={modalUpdate.visible}
        close={modalUpdate.close}
        refreshDashboard={refreshDashboard}
      />
      <AntdDropdown menu={{ items }} className="menuActions">
        <AntdButton>
          Actions <DownOutlined />
        </AntdButton>
      </AntdDropdown>

      {modalDeprecate.visible && <ModalDesactivationReactivation />}
    </>
  );
}

export default CellDetailsAndActions;
